export default __webpack_public_path__ + "static/media/Obinna1.5b6a4b56.jpg";